jQuery(document).ready(function ($) {
    $('.scrolling-gallery__gallery').each(function () {
        const gallery_id = $(this).attr('id');

        const scrolling_gallery = new Swiper(`#${gallery_id}`, {
            loop: true,

            slidesPerView: 1,

            spaceBetween: 24,

            centeredSlides: true,
            // centeredSlides shows a partial next slide from the second-to-last
            // position, but Swiper's default only appends loop clones at the last
            // slide. loopAdditionalSlides: 1 shifts that threshold one slide
            // earlier so the clone is always present when centeredSlides needs it.
            loopAdditionalSlides: 1,

            slideClass: 'scrolling-gallery__image',

            grabCursor: true,

            autoplay: {
                delay: 5000,
            },
            speed: 500,

            scrollbar: {
                el: '.scrolling-gallery__gallery--scrollbar',
                draggable: true,
            }
        });
    });
});